import { Card, CardContent } from '@sr/ui-library';
import { UseFormReturn } from 'react-hook-form';
import { AddressCityField } from './fields/addressCity/AddressCityField';
import { AddressCountryField } from './fields/addressCountry/AddressCountryField';
import { AddressLineField } from './fields/addressLine/AddressLineField';
import { AddressPostcodeField } from './fields/addressPostcode/AddressPostcodeField';
import { AddressSearchField } from './fields/addressSearch/AddressSearchField';
import { AddressStateField } from './fields/addressState/AddressStateField';
import { WorkspaceDetailsFormValues } from './shared/types';

interface WorkspaceDetailsAddressSectionProps {
  addressSearchResetKey?: number;
  form: UseFormReturn<WorkspaceDetailsFormValues>;
}

/**
 * Address section — pure UI, owns no form state; receives the shared form
 * instance from WorkspaceDetailsForm. Edits the workspace's single street
 * address (legacy parity — v2 AddressDetailsForm). Always editable, no
 * edit-mode toggle (matches the Entity Details pattern).
 */
export const WorkspaceDetailsAddressSection = ({
  addressSearchResetKey = 0,
  form,
}: WorkspaceDetailsAddressSectionProps) => (
  <section className="space-y-4">
    <h2 className="text-base font-medium text-neutral-950">Address</h2>

    <Card className="rounded-lg border-neutral-300 shadow-none @container">
      <CardContent className="grid grid-cols-1 gap-x-4 gap-y-6 p-5 @2xl:grid-cols-2">
        <AddressCountryField control={form.control} />
        <AddressSearchField form={form} resetKey={addressSearchResetKey} />
        <AddressLineField control={form.control} />
        <AddressCityField control={form.control} />
        <AddressStateField control={form.control} />
        <AddressPostcodeField control={form.control} />
      </CardContent>
    </Card>
  </section>
);
